module.exports = __webpack_public_path__ + "img/elaterna-header_1920x120px.7eb62215.jpg";